import { useEffect, useState } from 'react'

export interface QrCountdown {
  readonly secondsLeft: number
  readonly expired: boolean
}

/**
 * Contagem regressiva client-side desde `obtainedAt` (ver o TTL estimado em
 * `wizardSteps.ts#QR_ASSUMED_TTL_SECONDS` — a Api nao devolve expiracao). `now` so e lido de
 * `Date.now()` na inicializacao preguicosa do `useState` e dentro do callback do interval —
 * nunca durante o corpo do render nem sincronamente no corpo do efeito (regras de pureza do
 * React) — entao, apos `obtainedAt` mudar, o valor exibido corrige sozinho em ate 1s.
 */
export function useQrCountdown(obtainedAt: string | null, ttlSeconds: number): QrCountdown {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (obtainedAt === null) {
      return
    }

    const interval = window.setInterval(() => {
      setNow(Date.now())
    }, 1_000)

    return () => {
      window.clearInterval(interval)
    }
  }, [obtainedAt])

  if (obtainedAt === null) {
    return { secondsLeft: ttlSeconds, expired: false }
  }

  const obtainedMs = new Date(obtainedAt).getTime()
  const elapsedSeconds = Math.floor((now - obtainedMs) / 1_000)
  const secondsLeft = Math.max(ttlSeconds - elapsedSeconds, 0)

  return { secondsLeft, expired: secondsLeft <= 0 }
}

export function formatCountdown(seconds: number): string {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes.toString()}:${remainingSeconds.toString().padStart(2, '0')}`
}
